import React from 'react';
import classnames from 'classnames';

import { Link } from 'gatsby';

import MenuIcon from '@paradigm/icons/src/mailru/navigation/menu.svg';
import LogoMRG from '../../assets/images/mrg_inline.svg';
import LogoMRGTouch from '../../assets/images/mrg_inline_touch.svg';

import SocialButtons from '../../components/SocialButtons';
import MenuLinks from './MenuLinks';

import * as S from './Menu.module.css';
import * as T from './Menu.types';
import { withMenuContext } from './MenuContext/MenuContext';

const Menu: React.FunctionComponent<T.IMenuContext> = ({
  show,
  toggle,
  services,
  additionalLinks,
  share = false,
  burgerColor = '#FC2C38',
  MainLogo,
  MainLogoTouch,
}) => {
  const menuClass = classnames(S.menu, S.menuAnimatable, {
    [S.menuVisible]: show,
  });

  return (
    <div className={menuClass} onClick={toggle}>
      <div className={S.appMenu} onClick={(e) => {e.stopPropagation()}}>
        <div className={S.menuIcons}>
          <MenuIcon
            width={32}
            className={S.menuCloseIcon}
            height={32}
            fill={burgerColor}
            onClick={toggle}
          />
          <Link to="/" className={S.menuLogoLink}>
            {MainLogo ? (
              <MainLogo className={S.menuLogoIcon} height={32} />
            ) : (
              <LogoMRG className={S.menuLogoIcon} height={32} />
            )}
            {MainLogoTouch ? (
              <MainLogoTouch className={S.menuLogoIconTouch} height={32} />
            ) : MainLogo ? (
              <MainLogo className={S.menuLogoIconTouch} height={32} />
            ) : (
              <LogoMRGTouch className={S.menuLogoIconTouch} height={32} />
            )}
          </Link>
        </div>
        <div className={S.menuList}>
          <MenuLinks links={services} toggle={toggle} />
        </div>
        <div className={S.menuList}>
          {additionalLinks && (
            <MenuLinks links={additionalLinks} toggle={toggle} />
          )}
          {share && <SocialButtons className={S.menuSocials} />}
        </div>
      </div>
    </div>
  );
};

export const MenuWithContext = withMenuContext<T.IMenuProps>(Menu);
